import React, { useState } from 'react';
import HeroSection from "../components/HeroSection";
import { UploadFile, WorkspaceType, STATES_TYPE, AuthResponse } from "../types/type";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { INIT_DATA_AUTH,  } from "../utils/constants";

import ValideOTPComponent from "../components/ValideOTPComponent";

import { useTranslation } from "react-i18next";


function ValidateComponent() {

  const { i18n } = useTranslation();

  const [stateUI, setStateUI] = useState<STATES_TYPE>({ state: "OTP_STATE" });
  const [, setDataAuth] = useState<AuthResponse>(INIT_DATA_AUTH);

  const [, setLoadOnly] = useState<boolean>(true)
  const [, setShowProgress] = useState(false);

  const [uploadFiles, setUploadFiles] = useState<UploadFile[]>([]);

  const [, setWorkspaceId] = useState<string | "">("");
  const [, setWorkspaceData] = useState<WorkspaceType | null>(null);

  const [formData, ] = useState({ init_email: "" });


  const changeLanguage = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);
  };


  return (
    <main className="min-h-screen font-gellix flex max-sm:flex-col md:flex-row gap-20 bg-cover bg-center md:p-20 max-sm:p-10 text-white" style={{ backgroundImage: "url('/images/bg.jpg')" }}>

      <select className="absolute right-4 top-4 bg-transparent outline-none flex gap-2" value={i18n.language} onChange={changeLanguage}>
        <option value="fr" className="text-black">FR</option>
        <option value="en" className="text-black">EN</option>
      </select>

      {/* Section Information */}
      <section className='flex-1 sticky top-0 h-[80vh] bg-pink-30 md:w-1/2'>
        <HeroSection />
      </section>

      {/* Section Upload */}
      <section className='flex-1 md:w-1/2 bg-yellow-30'>

        {/* Block ToastConiatner */}
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={true} newestOnTop={false}
          closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />

        {/* Block valid OTP */}
        {stateUI?.state === "OTP_STATE" && <ValideOTPComponent 
          email={formData.init_email} 
          uploadFiles={uploadFiles}
          setStateUI={setStateUI} 
          setLoadOnly={setLoadOnly} 
          setDataAuth={setDataAuth} 
          setWorkspaceData={setWorkspaceData}
          setUploadFiles={setUploadFiles}
          setShowProgress={setShowProgress}
          setWorkspaceId={setWorkspaceId}
        />}

      </section>
    </main>
  );
}

export default ValidateComponent;
